const clickItems = document.querySelectorAll('.js-dropdown > .c-nav__link');
const mobileMenuItems = document.querySelectorAll('.js-menu-click');
let active = null;

if (clickItems) {
  clickItems.forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();

      if (active) {
        // Close the active dropdown
        active.classList.remove('dropdown-active');
      }

      if (active === item.parentElement) {
        // Empty active
        active = null;
      } else {
        // Open the dropdown
        item.parentElement.classList.add('dropdown-active');
        active = item.parentElement;
      }
    });
  });
}

if (mobileMenuItems) {
  mobileMenuItems.forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();

      // Toggle the dropdown
      item.classList.toggle('menu-active');

      // If another dropdown is open, close it
      mobileMenuItems.forEach(openCheckItem => {
        if (
          openCheckItem !== item &&
          openCheckItem.classList.contains('menu-active')
        ) {
          openCheckItem.classList.remove('menu-active');
        }
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/clicks.js